// @flow

import React from "react";

import { OldValue, ValueList } from "../styles";
import LinkedRoom from "src/components/messages/Chat/Notification/LinkedRoom";

import type { RoomId, ChatroomAddress } from "src/types";

type Props = {
  filteredOldValues: Array<RoomId>,
  oldAddresses: Array<ChatroomAddress>,
  disableTitleHyperlink: boolean
};

const DiffOldConversationValues = ({
  filteredOldValues,
  oldAddresses,
  disableTitleHyperlink
}: Props) => {
  return (
    <OldValue>
      <ValueList>
        {filteredOldValues.map((val, id) => (
          <LinkedRoom
            id={`${val}`}
            key={id}
            disableTitleHyperlink={disableTitleHyperlink}
            chatroomAddress={oldAddresses[id]}
          />
        ))}
      </ValueList>
    </OldValue>
  );
};

export default DiffOldConversationValues;
